/* eslint-disable global-require */
import React from 'react'

import { Icon } from 'Icon'

export const hero = {
  header: 'No.1 recipe box for choice',
  subheader: 'Over 75 recipes every week',
}

export const CTA = {
  text: 'Get started',
  stickyCTA: 'Get started with 50% off',
  join: (
    <span>
      Get started{' '}
      <Icon
        name="fa-angle-right"
        size="1.5rem"
        style={{ marginLeft: '8px', verticalAlign: 'text-top' }}
      />
    </span>
  ),
  loggedIn: {
    text: 'See Menu',
    join: (
      <span>
        See Menu{' '}
        <Icon
          name="fa-angle-right"
          size="1.5rem"
          style={{ marginLeft: '8px', verticalAlign: 'text-top' }}
        />
      </span>
    ),
  },
}

export const PROMO_CODE_DATA = {
  defaultPromoCode: 'DTI-SB-502525',
  defaultBannerText: 'Get 50% off your first box and 25% off your first two months',
  defaultDescriptionLines: [
    `Get 50% off your first box!`,
    `Then 25% off all other boxes you order in your first two months.`,
  ],
}

export const emailForm = {
  emailRequired: 'Please provide a valid email address.',
  serverError: 'There is a technical issue, please try again later.',
  success: 'Hooray! We’ll let you know as soon as you can place your order.',
}

export const knownVariants = ['default', 'tv']

export const defaultVariant = 'default'

export const joeWicks =
  "“I love coming home to a Gousto box with four different banging recipes each week. With so many dishes to choose from there's always something new to try!”"
export const carousel = {
  title: 'Who says Tuesday can’t taste like Saturday?',
  subtitle:
    'Tuck into our 75 dish menu, filled with global cuisines, family favourites and Joe Wicks approved healthy options. Meals for every appetite – sorted.',
}
export const seo = {
  title: 'Recipe Boxes | Get Fresh Food & Recipes Delivered | Gousto',
  meta: [
    {
      name: 'description',
      content:
        'Change the way you eat with our easy to follow recipes. We deliver fresh boxes of ingredients and delicious recipes 7 days a week. Get started now!',
    },
    {
      name: 'keywords',
      content: 'Gousto, recipe delivery, ingredients, fresh, healthy food, cooking, recipe box',
    },
  ],
}

export const homeConfig = {
  hero,
  CTA,
  PROMO_CODE_DATA,
  emailForm,
  knownVariants,
  defaultVariant,
  joeWicks,
  carousel,
  seo,
}
